import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/styles/ui/accordion";
import { ChevronDown } from "lucide-react";
import React from "react";

export const MappingSearchResultGroup = ({
  label,
  children,
  showTotalCount = false,
}: {
  label: string;
  children: React.ReactNode;
  showTotalCount?: boolean;
}) => {
  return (
    <Accordion
      className="flex flex-col items-start self-stretch"
      type="single"
      collapsible
      defaultValue={label}
    >
      <AccordionItem value={label} className="self-stretch">
        <AccordionTrigger className="group/chev flex items-center gap-[4px] pl-2 py-5 self-stretch cursor-pointer select-none">
          <ChevronDown className="w-[14px] h-[14px] aspect-square stroke-[#737373] -rotate-90 group-data-[state=open]/chev:rotate-0 transition-transform" />
          <span className="caption-1-semibold text-[#0A0A0A] flex-1">
            {label}
          </span>
          {showTotalCount && children && (
            <span className="caption-1-semibold text-blue-500">
              {React.Children.count(children)}
            </span>
          )}
        </AccordionTrigger>
        <AccordionContent className="flex py-0 px-5 flex-col items-start gap-[20px] self-stretch pb-2">
          {children}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
